<template>
  <label class="w-100"
         for="rapidAccessSubType">
    Rapid access subtype

    <template class="mt-1">
      <p v-for="option in rapidAccessSubtypes"
         :key="option.name"
         class="grey--text font-italic ma-0">
        {{ option.name }} - {{ option.description }}
        <span v-if="option.note" class="custom-text-danger">
          **{{ option.note }}!**
        </span>
      </p>
    </template>

    <b-form-select id="rapidAccessSubType"
                   v-model="proposal.general.rapid_access_subtype"
                   :class="['mt-2', {'custom-invalid-input-border': isInvalid.$error}]"
                   :disabled="!editable">
      <option v-for="subtype in rapidAccessSubtypes"
              :key="subtype.name"
              :value="subtype.name"
              v-text="getRapidAccessSubtypeText(subtype)"/>
    </b-form-select>

  </label>
</template>

<script>
  import { importSpecification } from '@/helpers/proposal-form';

  export default {
    name: 'RapidAccessSubtype',
    props: {
      editable: {
        type: Boolean,
        default: true,
      },
      infrastructure: {
        type: String,
        default: 'synchrotron',
      },
      isInvalid: {
        type: Object,
        default: () => ({
          $error: false,
          $touch() { /* Nothing to be done here */
          },
        }),
      },
      value: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        rapidAccessSubtypes: [],
        proposal: this.value,
      };
    },
    watch: {
      'proposal.general': {
        handler() {
          this.isInvalid.$touch();
          this.$emit('input', this.proposal);
        },
        deep: true,
        immediate: true,
      },
      'value.general': {
        handler() {
          this.proposal = this.value;
        },
        deep: true,
      },
    },
    async created() {
      await this.getRapidAccessSubtypes();
    },
    methods: {
      async getRapidAccessSubtypes() {
        const specification = await importSpecification(this.infrastructure);
        this.rapidAccessSubtypes = specification.rapidAccessSubtypes;
      },
      getRapidAccessSubtypeText(subtype) {
        return `${subtype.name}${subtype.note ? `: ${subtype.note.toLowerCase()}` : ''}`;
      },
    },
  };
</script>
